<template>
  <div>
    <div class="wrapperspntxt">
      <spinLoader />
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
import spinLoader from './spinLoader.vue';

export default {
  name: 'SpinLoaderText',
  props:["text"],
  components:{
    spinLoader
  }
}
</script>

<style scoped>
.wrapperspntxt{
  display: flex;
  flex-direction: column;
  align-items: center;
}

span{
  display: block;
  padding-top: 20px;
  font-family: "PT Sans";
  font-size: 16px;
}
</style>